
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { getContractWithdrawalContactPhoneNumber1, getContractWithdrawalContactPhoneNumber2 } from "@/app/utils/EnvConfig";

@Component
export default class ContractWithdrawalPhone extends Vue {
    private phoneNumber1: string = getContractWithdrawalContactPhoneNumber1();
    private phoneNumber2: string = getContractWithdrawalContactPhoneNumber2();
}
